import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Box, Button, Grid, Table, TableBody, TableCell, TableRow } from '@mui/material';
import apiManagerUser from 'api/manager-users';
import { TooltipCC } from 'components/common';
import { BreadcrumbsCC, ContainerPage } from 'components/Layout';
import { PaginationButtons, TableHeaderCC, TypographyCellCC } from 'components/Table';
import { useResponsiveCC } from 'hooks';
import _, { lowerCase } from 'lodash';
import { headCellsStatistics } from 'mock';
import moment from 'moment';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getAccessToken, getRefreshToken } from 'utils/cookies';
import { toastWarning } from 'utils/helpers';
import apiManagerRoom from '../../api/manager-meeting';
import { ReactComponent as IconDownloadFiles } from '../../assets/svg/IconDownloadStatistics.svg';
import API_MAP, { PATH_ROOT } from '../../constants/api';
import { setStateModalDetail } from './modelPeriodSlice';
import { transHeadCells } from 'utils/functions';
import ItemMeetingInfoStatistics from './components/ItemMeetingInfoStatistics';
import { IconClose } from 'assets/icons';

export default function ParticipantStatistics() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [statisticsRoom, setStatisticsRoom] = useState();
    const [participantsRoom, setParticipantsRoom] = useState([]);
    const [checkOpenIcon, setCheckOpenIcon] = useState([]);
    const ONE_HOUR = 60;
    const [currentPage, setCurrentPage] = useState(1);
    const { roomIdByURL } = useParams();
    const startTimeRoom = localStorage.getItem('StartTimeRoom');
    const dispatch = useDispatch();
    const { getWidthRatio } = useResponsiveCC();

    const caculateTimeDuration = (timeStart, timeEnd) => {
        const _timeStart = moment(timeStart);
        const _timeEnd = moment(timeEnd);
        const duration = _timeEnd.diff(_timeStart, 'minutes');
        return duration;
    };

    const caculateTotalTimeDurationToHourAndMinuteNoText = (participants) => {
        const timeTotal = participants?.timeDetails?.reduce((accumulator, currentValue) => {
            return accumulator + caculateTimeDuration(currentValue.started_time, currentValue.ended_time);
        }, 0);
        const durationMinutes = timeTotal;

        return _.parseInt(durationMinutes);
    };

    const convertTimeToHourAndMinute = (timeStart, timeEnd) => {
        const duration = caculateTimeDuration(timeStart, timeEnd);
        const durationHour = Math.floor(duration / ONE_HOUR);
        const durationMinutes = duration % ONE_HOUR;

        if (durationHour !== 0) {
            if (durationMinutes !== 0) {
                return `${durationHour} ${t('meeting.table.hour')} ${durationMinutes} ${t('meeting.table.minute')}`;
            } else {
                return `${durationHour} ${t('meeting.table.hour')}`;
            }
        } else if (durationMinutes !== 0) {
            return `${durationMinutes} ${t('meeting.table.minute')}`;
        } else {
            return `<1 ${t('meeting.table.minute')}`;
        }
    };

    const convertTimeToMinute = (timeStart, timeEnd) => {
        const durationMinutes = caculateTimeDuration(timeStart, timeEnd);

        return durationMinutes;
    };

    const getDetailStatisticsRoom = (roomId, currentPage, startTimeRoom = false) => {
        if (startTimeRoom && startTimeRoom !== 'null' && startTimeRoom !== null) {
            return apiManagerRoom.getDetailStatisticsRoom(roomId, currentPage, startTimeRoom);
        } else return apiManagerRoom.getDetailStatisticsRoom(roomId, currentPage);
    };

    const checkRefreshToken = async (refresh_token) => {
        return await apiManagerUser.checkRefreshToken(refresh_token);
    };

    const downloadDetailStatistics = async () => {
        try {
            const newToken = await checkRefreshToken(getRefreshToken());

            const link = document.createElement('a');
            link.href = `${API_MAP.ROOM_API.DOWNLOAD_DETAIL_STATISTICS}?roomId=${roomIdByURL}&token=${newToken}&start=${startTimeRoom}`;
            link.download = 'document.xlsx';

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        } catch (error) {
            const link = document.createElement('a');
            link.href = `${
                API_MAP.ROOM_API.DOWNLOAD_DETAIL_STATISTICS
            }?roomId=${roomIdByURL}&token=${getAccessToken()}&start=${startTimeRoom}`;
            link.download = 'document.xlsx';

            // Append to html link element page
            document.body.appendChild(link);

            // Start download
            link.click();

            // Clean up and remove the link
            link.parentNode.removeChild(link);
        }
    };

    const getRoom = (data, startTimeRoom = false) => {
        if (startTimeRoom) {
            return apiManagerRoom.getRoom(data, startTimeRoom);
        } else return apiManagerRoom.getRoom(data);
    };

    useEffect(() => {
        getRoom(roomIdByURL, startTimeRoom)
            .then((r) => {
                if (r.status === 200) {
                    getDetailStatisticsRoom(r.data[0].parentRoomId || r.data[0].roomId, currentPage - 1, startTimeRoom)
                        .then((response) => {
                            setStatisticsRoom(response);
                            setParticipantsRoom(() => {
                                let dataParticipant = response?.participants?.map((participant) => {
                                    return {
                                        userId: participant.userId,
                                        username: participant.username,
                                        lowerName: lowerCase(participant.username),
                                        email: participant.email,
                                        name: participant.name,
                                        joined_time:
                                            participant.timeDetails.length >= 1
                                                ? caculateTotalTimeDurationToHourAndMinuteNoText(participant)
                                                : _.parseInt(-1),
                                        timeDetails: participant.timeDetails.map((timeDetail) => ({
                                            started_time: timeDetail.started_time,
                                            ended_time: timeDetail.ended_time,
                                        })),
                                    };
                                });
                                return _.orderBy(dataParticipant, ['joined_time', 'lowerName'], ['desc', 'asc']);
                            });
                        })
                        .catch((error) => {
                            console.log('ERR: ', error);
                        });
                }
            })
            .catch((e) => {
                if (e.response.data.data === 'PERMISSION_DENIED') {
                    toastWarning(t('meeting.permissionDenied'));
                    navigate(`${PATH_ROOT}/manager-meeting`);
                }
            });

        return () => {
            dispatch(setStateModalDetail({ isOpenModalDetail: false }));
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    return (
        <ContainerPage>
            <BreadcrumbsCC>
                <Box>
                    <Button
                        size="small"
                        startIcon={<IconDownloadFiles />}
                        onClick={() => {
                            downloadDetailStatistics();
                        }}
                    >
                        {t('actions.export-statistics')}
                    </Button>
                    <Button
                        className='stroke'
                        variant="outlined"
                        size="small"
                        startIcon={<IconClose />}
                        sx={{ marginLeft: '16px' }}
                        onClick={() => {
                            navigate(`${PATH_ROOT}/manager-meeting/details/` + statisticsRoom?.roomId);
                        }}
                    >
                        {t('actions.closePage')}
                    </Button>
                </Box>
            </BreadcrumbsCC>
            <div className={'wrapper-loading'} style={{ boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.25)' }}>
                <div className={'main-container-content'}>
                    <div className="row" style={{ height: '100%' }}>
                        <div className="col-md-12">
                            <div className="row">
                                {/* HEADER PARTICIPANTS STATISTICS */}
                                <div className="col-md-12 margin-bottom">
                                    <div className="row">
                                        <div className="col-md-12 margin-bottom" style={{ width: '100%' }}>
                                            <div className="row"></div>
                                        </div>
                                        <Grid container spacing={2}>
                                            <Grid item xs={9}>
                                                <ItemMeetingInfoStatistics
                                                    labelKey={'meeting.detail'}
                                                    content={statisticsRoom?.roomName && statisticsRoom?.roomName}
                                                />
                                            </Grid>
                                            <Grid item xs={3} sx={{ display: 'flex', justifyContent: 'end' }}>
                                                <ItemMeetingInfoStatistics
                                                    labelKey={'meeting.idMeeting'}
                                                    content={statisticsRoom?.roomId && statisticsRoom?.roomId}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Box
                                            sx={{
                                                marginTop: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <ItemMeetingInfoStatistics
                                                labelKey={'meeting.time-start'}
                                                content={moment(statisticsRoom?.startTime).format(
                                                    'DD/MM/YYYY HH:mm:ss',
                                                )}
                                            />
                                            <ItemMeetingInfoStatistics
                                                labelKey={'meeting.time-end'}
                                                content={moment(statisticsRoom?.endTime).format('DD/MM/YYYY HH:mm:ss')}
                                            />
                                            <ItemMeetingInfoStatistics
                                                labelKey={'meeting.time-duration'}
                                                content={convertTimeToHourAndMinute(
                                                    statisticsRoom?.startTime,
                                                    statisticsRoom?.endTime,
                                                )}
                                            />
                                            <ItemMeetingInfoStatistics
                                                labelKey={'meeting.number-participants'}
                                                content={statisticsRoom?.realTotalParticipants}
                                            />
                                        </Box>
                                    </div>
                                </div>
                                {/* BODY PARTICIPANTS STATISTICS */}
                                <div className="col-md-12" style={{ marginTop: '20px' }}>
                                    <Table stickyHeader bordered hover className={'vmp-table'}>
                                        <TableHeaderCC headCellTable={transHeadCells(headCellsStatistics, t)} />
                                        <TableBody>
                                            {participantsRoom?.map((participant, index) => {
                                                let timeDetailsLength = participant.timeDetails.length;
                                                return (
                                                    <Fragment key={participant.id}>
                                                        <TableRow key={participant.id}>
                                                            <TableCell width="1%" style={{ textAlign: 'center' }}>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell>
                                                                <TooltipCC
                                                                    title={participant.name}
                                                                    placement="bottom-start"
                                                                >
                                                                    <TypographyCellCC
                                                                        sx={{ width: getWidthRatio(200) }}
                                                                    >
                                                                        {participant.name}
                                                                    </TypographyCellCC>
                                                                </TooltipCC>
                                                            </TableCell>
                                                            <TableCell>
                                                                <TooltipCC
                                                                    title={participant.email}
                                                                    placement="bottom-start"
                                                                >
                                                                    <TypographyCellCC
                                                                        sx={{ width: getWidthRatio(250) }}
                                                                    >
                                                                        {participant.email}
                                                                    </TypographyCellCC>
                                                                </TooltipCC>
                                                            </TableCell>
                                                            <TableCell>
                                                                <TooltipCC
                                                                    title={
                                                                        participant.timeDetails.length >= 1 &&
                                                                        moment(
                                                                            participant?.timeDetails[0].started_time,
                                                                        ).format('DD/MM/YYYY HH:mm:ss')
                                                                    }
                                                                    placement="bottom-start"
                                                                >
                                                                    <TypographyCellCC
                                                                        sx={{ width: getWidthRatio(210) }}
                                                                    >
                                                                        {participant.timeDetails.length >= 1 &&
                                                                            moment(
                                                                                participant?.timeDetails[0]
                                                                                    .started_time,
                                                                            ).format('DD/MM/YYYY HH:mm:ss')}
                                                                    </TypographyCellCC>
                                                                </TooltipCC>
                                                            </TableCell>
                                                            <TableCell>
                                                                <TooltipCC
                                                                    title={
                                                                        participant.timeDetails.length >= 1 &&
                                                                        (participant.timeDetails[timeDetailsLength - 1]
                                                                            .ended_time
                                                                            ? moment(
                                                                                  participant?.timeDetails[
                                                                                      timeDetailsLength - 1
                                                                                  ]?.ended_time,
                                                                              ).format('DD/MM/YYYY HH:mm:ss')
                                                                            : t('actions.statistics-unknow'))
                                                                    }
                                                                    placement="bottom-start"
                                                                >
                                                                    <TypographyCellCC
                                                                        sx={{ width: getWidthRatio(200) }}
                                                                    >
                                                                        {participant.timeDetails.length >= 1 &&
                                                                            (participant.timeDetails[
                                                                                timeDetailsLength - 1
                                                                            ]?.ended_time
                                                                                ? moment(
                                                                                      participant?.timeDetails[
                                                                                          timeDetailsLength - 1
                                                                                      ]?.ended_time,
                                                                                  ).format('DD/MM/YYYY HH:mm:ss')
                                                                                : t('actions.statistics-unknow'))}
                                                                    </TypographyCellCC>
                                                                </TooltipCC>
                                                            </TableCell>
                                                            <TableCell style={{ textAlign: 'end' }}>
                                                                <TypographyCellCC>
                                                                    {participant.timeDetails.length >= 1
                                                                        ? participant.joined_time !== -1
                                                                            ? participant.joined_time === 0
                                                                                ? '<1'
                                                                                : participant.joined_time
                                                                            : t('actions.statistics-unknow')
                                                                        : '0'}
                                                                </TypographyCellCC>
                                                            </TableCell>
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex' }}>
                                                                    {participant.timeDetails.length >= 1
                                                                        ? t('meeting.table.join')
                                                                        : t('meeting.table.not_join')}
                                                                    {participant.timeDetails.length > 1 ? (
                                                                        !checkOpenIcon.find(
                                                                            (username) =>
                                                                                username === participant.username,
                                                                        ) ? (
                                                                            <ArrowDropDownIcon
                                                                                fontSize="small"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    setCheckOpenIcon((prevData) => [
                                                                                        ...prevData,
                                                                                        participant.username,
                                                                                    ]);
                                                                                }}
                                                                            />
                                                                        ) : (
                                                                            <ArrowDropUpIcon
                                                                                fontSize="small"
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    setCheckOpenIcon((prevData) =>
                                                                                        prevData.filter(
                                                                                            (username) =>
                                                                                                username !==
                                                                                                participant.username,
                                                                                        ),
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        <></>
                                                                    )}
                                                                </Box>
                                                            </TableCell>
                                                        </TableRow>
                                                        {checkOpenIcon.find(
                                                            (username) => username === participant.username,
                                                        ) === participant.username ? (
                                                            participant.timeDetails.map((timeDetail, index) => {
                                                                return (
                                                                    <TableRow key={participant.id} class="table-light">
                                                                        <TableCell width="1%"></TableCell>
                                                                        <TableCell width="21.3%"></TableCell>
                                                                        <TableCell width="26%">
                                                                            {t('meeting.table.attend_times')}{' '}
                                                                            {index + 1}
                                                                        </TableCell>
                                                                        <TableCell width="13.5%">
                                                                            <TooltipCC
                                                                                title={moment(
                                                                                    timeDetail?.started_time,
                                                                                ).format('DD/MM/YYYY HH:mm:ss')}
                                                                                placement="bottom-start"
                                                                            >
                                                                                <TypographyCellCC
                                                                                    sx={{ width: getWidthRatio(210) }}
                                                                                >
                                                                                    {moment(
                                                                                        timeDetail?.started_time,
                                                                                    ).format('DD/MM/YYYY HH:mm:ss')}
                                                                                </TypographyCellCC>
                                                                            </TooltipCC>
                                                                        </TableCell>
                                                                        <TableCell width="13.5%">
                                                                            <TooltipCC
                                                                                title={
                                                                                    timeDetail?.ended_time
                                                                                        ? moment(
                                                                                              timeDetail?.ended_time,
                                                                                          ).format(
                                                                                              'DD/MM/YYYY HH:mm:ss',
                                                                                          )
                                                                                        : t('actions.statistics-unknow')
                                                                                }
                                                                                placement="bottom-start"
                                                                            >
                                                                                <TypographyCellCC
                                                                                    sx={{ width: getWidthRatio(210) }}
                                                                                >
                                                                                    {timeDetail?.ended_time
                                                                                        ? moment(
                                                                                              timeDetail?.ended_time,
                                                                                          ).format(
                                                                                              'DD/MM/YYYY HH:mm:ss',
                                                                                          )
                                                                                        : t(
                                                                                              'actions.statistics-unknow',
                                                                                          )}
                                                                                </TypographyCellCC>
                                                                            </TooltipCC>
                                                                        </TableCell>
                                                                        <TableCell
                                                                            width="13.5%"
                                                                            sx={{ textAlign: 'end' }}
                                                                        >
                                                                            <TooltipCC
                                                                                placement="bottom-end"
                                                                                title={
                                                                                    timeDetail?.ended_time
                                                                                        ? convertTimeToMinute(
                                                                                              timeDetail?.started_time,
                                                                                              timeDetail?.ended_time,
                                                                                          ) === 0
                                                                                            ? '<1'
                                                                                            : convertTimeToMinute(
                                                                                                  timeDetail?.started_time,
                                                                                                  timeDetail?.ended_time,
                                                                                              )
                                                                                        : t('actions.statistics-unknow')
                                                                                }
                                                                            >
                                                                                <TypographyCellCC
                                                                                    sx={{
                                                                                        width: getWidthRatio(210),
                                                                                        textAlign: 'end',
                                                                                    }}
                                                                                >
                                                                                    {timeDetail?.ended_time
                                                                                        ? convertTimeToMinute(
                                                                                              timeDetail?.started_time,
                                                                                              timeDetail?.ended_time,
                                                                                          ) === 0
                                                                                            ? '<1'
                                                                                            : convertTimeToMinute(
                                                                                                  timeDetail?.started_time,
                                                                                                  timeDetail?.ended_time,
                                                                                              )
                                                                                        : t(
                                                                                              'actions.statistics-unknow',
                                                                                          )}
                                                                                </TypographyCellCC>
                                                                            </TooltipCC>
                                                                        </TableCell>
                                                                        <TableCell></TableCell>
                                                                    </TableRow>
                                                                );
                                                            })
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </Fragment>
                                                );
                                            })}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        {/* FOOTER PARTICIPANTS STATISTICS */}
                        <div className="col-md-12">
                            {statisticsRoom?.totalPage === 1 ? (
                                ''
                            ) : (
                                // <Paging
                                //     setCurrentPage={setCurrentPage}
                                //     count={statisticsRoom?.participants?.length}
                                //     currentPage={currentPage}
                                //     handleChangeCurrentPage={handleChangeCurrentPage}
                                //     totalPage={statisticsRoom?.totalPage}
                                //     totalResult={statisticsRoom?.totalParticipants}
                                //     previousPage={previousPage}
                                //     nextPage={nextPage}
                                // ></Paging>
                                <PaginationButtons
                                    page={currentPage - 1}
                                    handleChangePage={(e, page) => {
                                        setCurrentPage(page);
                                    }}
                                    limit={10}
                                    total={statisticsRoom?.totalParticipants}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ContainerPage>
    );
}
